class IngredientsPage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.ingredientsTabs();
    this.ingredientsAccordion();
    this.removeInertAttribute();
    this.listMobileImageReveal();
    this.removeClickFocus();

    window.addEventListener("resize", () => this.removeInertAttribute());
  }

  ingredientsTabs() {
    const buttons = document.querySelectorAll(
      ".ingredients-header-tabs .nav-cta"
    );
    const items = document.querySelectorAll(".ingredients-item");

    buttons.forEach((btn, index) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();

        buttons.forEach((button) => button.classList.remove("active"));
        btn.classList.add("active");

        items.forEach((item) => {
          const gridStructure = item.querySelector(
            ".ingredients-item-grid-structure"
          );
          const listStructure = item.querySelector(
            ".ingredients-item-list-structure"
          );

          if (index === 0) {
            gridStructure.classList.add("active");
            gridStructure.removeAttribute("inert");
            listStructure.classList.remove("active");
            listStructure.setAttribute("inert", "");
          } else {
            gridStructure.classList.remove("active");
            gridStructure.setAttribute("inert", "");
            listStructure.classList.add("active");
            listStructure.removeAttribute("inert");
          }
        });
      });
    });
  }

  ingredientsAccordion() {
    const listItems = document.querySelectorAll(
      ".ingredients-item-list-structure"
    );
    listItems.forEach((item) => {
      const content = item.querySelector(".ingredient-item-nested-block-content");

      content.classList.remove("open");
      content.setAttribute("inert", "");

      const toggleAccordion = () => {
        listItems.forEach((otherItem) => {
          const otherContent = otherItem.querySelector(
            ".ingredient-item-nested-block-content"
          );
          if (otherContent !== content) {
            otherContent.classList.remove("open");
            otherContent.setAttribute("inert", "");
          }
        });

        const isOpen = content.classList.contains("open");
        if (isOpen) {
          content.classList.remove("open");
          content.setAttribute("inert", "");
        } else {
          content.classList.add("open");
          content.removeAttribute("inert");
        }

        this.toggleAccordion(item); 
        this.listMobileImageReveal();
      };

      item.addEventListener("click", (e) => {
        if (content.contains(e.target)) return;
        toggleAccordion();
      });

      item.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggleAccordion();
        }
      });
    });
  }

toggleAccordion(item) {
  const inner = item.querySelector(".grid-content-fallback");
  const content = item.querySelector(".ingredient-item-nested-block-content");
  const isOpen = content?.classList.contains("open");

  const CLOSED = "46.8px";


  document.querySelectorAll(".ingredients-item-list-structure").forEach((el) => {
    if (el === item) return;
    const otherInner = el.querySelector(".grid-content-fallback");
    if (otherInner) otherInner.style.height = CLOSED;
  });


  if (!inner) return;

  if (isOpen) {
    inner.style.height = "auto";
    const h = inner.offsetHeight + "px";
    inner.style.height = CLOSED;
    requestAnimationFrame(() => inner.style.height = h);
  } else {
    inner.style.height = CLOSED;
  }
}


  removeInertAttribute() {
    const ingredientsItems = document.querySelectorAll(
      ".ingredients-item-list-structure"
    );
    const mediaWidth = window.innerWidth;

    if (mediaWidth <= 1010) {
      ingredientsItems.forEach((item) => {
        item.removeAttribute("inert");
      });
    }
  }

  removeClickFocus() {
   const gridElements = document.querySelectorAll('.ingredients-item-grid-inner-structure');
    gridElements .forEach(el => {
    el.addEventListener('mousedown', (e) => {
      e.preventDefault(); 
    });
  });

  }

  listMobileImageReveal() {
    const listItems = document.querySelectorAll(
      ".ingredients-block-content .ingredient-item"
    );
    const listItemsMobileDiv = document.querySelector(
      ".ingredients-list-tabs-images-mobile"
    );
    const listItemsMobile = document.querySelectorAll(
      ".ingredients-list-tabs-images-mobile .ingredient-item"
    );
    const ingredientsHeader = document.querySelector(".ingredients-header");

    window.addEventListener("scroll", () => {
      const headerBottom = ingredientsHeader.getBoundingClientRect().bottom;
      listItemsMobileDiv.classList.toggle("box-shadow", headerBottom < 0);
    });

    listItemsMobile.forEach((item) => {
      item.classList.remove("active");
      listItemsMobileDiv.classList.remove("active");
    });

    listItems.forEach((item, index) => {
      const content = item.querySelector(".ingredient-item-nested-block-content");
      if (content && content.classList.contains("open")) {
        if (listItemsMobile[index]) {
          listItemsMobileDiv.classList.add("active");
          listItemsMobile[index].classList.add("active");
        }
      }
    });
  }
}

customElements.define("ingredients-page", IngredientsPage);